<template>
  <HeadMeta />
  <HeaderMain v-if="showHeaderFooter" />
  <router-view />
  <FooterMain/>
</template>

<style>
#app {

  background: linear-gradient(-90deg, rgba(27,15,60,1) 0%, rgba(22,9,45,1) 100%);
}
</style>
<script>
import HeadMeta from '../src/components/Meta.vue'; 
import HeaderMain from '../src/components/Header.vue'; 
import FooterMain from '../src/components/Footer.vue';
export default {
  name: 'App',
  data(){
    return {
      api : {
        device_type : 'android',
        device_token : '1234567890',
        token : '5QuAW2/Zspqnm4G4yFaAN60EZU/UdP531XWprm3ZMzxdUAa7rJg41yx6Cm+4/4AH',
        base_url : 'https://rockstar.dev.retrocubedev.com/api',
      }
    }
  },
  provide(){
    return {
      api : this.api,
    }
  },
  components: {
    HeadMeta,
    HeaderMain,
    FooterMain
  },
  computed: {
    showHeaderFooter() {
      // Hide header and footer on login page
      return this.$route.path !== '/login';
    }
  }
}
</script>